import React from 'react';

import TopEventsRank from './TopEventsRank/TopEventsRank';
import { DateTime } from 'luxon';
import './item.css';
import { cn } from '@wwe-portal/ui/lib/lib';

function whichRank(rank) {
  switch (rank) {
    case 1:
      return <TopEventsRank rank={rank} place="bg-[#ffe432] text-blue700" />;
    case 2:
      return <TopEventsRank rank={rank} place="bg-[#00baff] text-blue700" />;
    case 3:
      return <TopEventsRank rank={rank} place="bg-green700 text-blue700" />;
    default:
      if (rank > 999) {
        return (
          <TopEventsRank
            place="bg-back200 text-text500"
            rank={rank}
            isCircle={false}
          />
        );
      }
      return <TopEventsRank place="bg-back200 text-text500" rank={rank} />;
  }
}

function TopEventsHeaderItem({
  eventId,
  rank,
  name,
  additionalName,
  endDate,
  isLast,
}: Readonly<{
  isLast: boolean;
  isPrevious: boolean;
  isThird: boolean;
  eventId: string;
  rank: number;
  name: string;
  additionalName?: string;
  endDate: string;
}>) {
  return (
    <div
      key={eventId}
      className={cn(
        'top-faction-items border-b-borderColor7 md:border-r-borderColor7 border-b-0 md:border-r',
        {
          'border-r-0': isLast,
          'md:border-r-0': isLast,
        }
      )}
    >
      <div className="flex h-full flex-col justify-around gap-3 py-[30px] text-center sm:py-[15px]">
        <div>{whichRank(rank)}</div>
        <div className="mt-[5px] flex h-full flex-col justify-around gap-3">
          <div className="mb-15 text-text500 text-xs">
            {additionalName ? `${name}-${additionalName}` : name}
          </div>
          <div className="text-text600 text-xs">
            {endDate ? DateTime.fromISO(endDate).toFormat('MM/dd/yyyy') : '-'}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopEventsHeaderItem;
